import Image from 'next/image';
import { useEffect } from 'react';
import { fireServedEvent } from '../../../Utils/CategoryPageUtils';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import { CategoryBanner, CategoryBannerCover } from './styled';

export default function CategoryBannerComponent(props) {
  let { bannerData, category_name, L1Page } = props;
  const deeplink = bannerData?.[0]?.deeplink;

  useEffect(() => {
    fireServedEvent(bannerData?.[0], category_name);
  }, []);

  const imageExists =
    bannerData?.[0]?.desktopImage || bannerData?.[0]?.mobileWebImage;

  const getDesktopImage = (banner) => {
    return banner?.desktopImage || banner?.mobileWebImage || banner?.image;
  };
  const getMobileImage = (banner) => {
    return banner?.mobileWebImage || banner?.desktopImage || banner?.image;
  };
  return imageExists ? (
    <AnchorCoverTag url={deeplink}>
      {' '}
      <CategoryBannerCover>
        <CategoryBanner L1Page={L1Page}>
          <Image
            className="carousel-mobile"
            src={getMobileImage(bannerData?.[0])}
            alt=""
            quality={80}
            priority={true}
            loading="eager"
            fill
            sizes="50vw"
          />
          <Image
            className="carousel-desktop"
            src={getDesktopImage(bannerData?.[0])}
            alt=""
            quality={80}
            priority={true}
            loading="eager"
            fill
            sizes="80vw"
          />
        </CategoryBanner>
      </CategoryBannerCover>
    </AnchorCoverTag>
  ) : null;
}
